module.exports = __webpack_public_path__ + "img/logo-pr.24b872b0.svg";